export default "/assets/images/smog-video.da188764ef54819c.mp4";